export default {
    GET_MY_ACTIVITY_LOGS: 'GET_MY_ACTIVITY_LOGS',
    SET_STEP_NUMBER: 'SET_STEP_NUMBER',
    CONFIGURE_DOMAIN_REQUIREMENT: 'CONFIGURE_DOMAIN_REQUIREMENT',
    CONFIGURE_MAIL_REQUIREMENT: 'CONFIGURE_MAIL_REQUIREMENT',
    SET_STATE_OPTIONS: 'SET_STATE_OPTIONS',
    SIGNUP_ATTEMPT: 'SIGNUP_ATTEMPT',
    SET_FIRST_FORM_DATA: 'SET_FIRST_FORM_DATA',
    VALIDATE_EMAIL: 'VALIDATE_EMAIL',
    CHANGE_VALIDATION_MAIL: 'CHANGE_VALIDATION_MAIL',
    UPDATE_BASIC_DETAILS_EMAIL: 'UPDATE_BASIC_DETAILS_EMAIL',
    SET_OTP_VERIFIED: 'SET_OTP_VERIFIED',
    DOMAIN_SEARCH: 'DOMAIN_SEARCH',
    SET_DOMAIN_SUGGESTIONS: 'SET_DOMAIN_SUGGESTIONS',
    SAVE_GET_DOMAIN_DATA: 'SAVE_GET_DOMAIN_DATA',
    SAVE_DOMAIN_DETAILS: 'SAVE_DOMAIN_DETAILS',
    GET_PRICING_DETAILS: 'GET_PRICING_DETAILS',
    SAVE_PLAN_DETAILS: 'SAVE_PLAN_DETAILS',
    PROCESS_CARD: 'PROCESS_CARD',
    BUY_INFINCE: 'BUY_INFINCE',
    BUSINESS_EMAIL: 'BUSINESS_EMAIL',
    TRIAL_SAVE: 'TRIAL_SAVE',
    BUSINESS_MAIL_ERROR: 'BUSINESS_MAIL_ERROR',
    SET_GET_DOMAIN_ERROR: 'SET_GET_DOMAIN_ERROR',
    SET_STRIPE_ERROR: 'SET_STRIPE_ERROR',
    BUSINESS_MAIL_VERIFY: 'BUSINESS_MAIL_VERIFY',
    SET_PASSWORD: 'SET_PASSWORD',
    BUSINESS_MAIL_VERIFY_ERROR: 'BUSINESS_MAIL_VERIFY_ERROR',
    INFINCE_URL: 'INFINCE_URL',
    REGISTERED_DOMAIN_STATUS:'REGISTERED_DOMAIN_STATUS',
    SET_EMAIL_PASSWORD_ERROR:'SET_EMAIL_PASSWORD_ERROR',
    CLEAR: 'CLEAR',
};
